import { useState } from 'react';
import { ButtonField, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ButtonGroupItem, InputField, TextareaField } from '@wk/components-react16';
import { API_URL } from '../../../config/constants';
import HttpService from "../../../config/http.service";
import { Toast } from '../../../services';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

const AddCategoryScoreType = ({ data }: any) => {
    const { isOpenAddEdit, setIsOpenAddEdit, selectedItem, setIsLoad } = data;
    const { authProject } = useSelector((state: RootState) => state.auth);
    const defaultFormObj = {
        id: selectedItem.id ? selectedItem.id : null,
        name: selectedItem.name ? selectedItem.name : "",
        code: selectedItem.code ? selectedItem.code : "",
        description: selectedItem.description ? selectedItem.description :"",
        projectId: selectedItem.projectId ? selectedItem.projectId : authProject.id,
    };
    const [formField, setFormField] = useState(defaultFormObj);

    const handleUserRequest = (origin: string) => {
        if (origin === 'esc' || origin === 'header' || origin === 'footer') {
            setIsOpenAddEdit(false);
        }
    }

    const handleInputChange = (event: any) => {
        const { name, value } = event.target;
        setFormField({
            ...formField,
            [name]: value
        });
    };

    const isValidInput = (formObj: any) => {
        if (!formObj.name || !formObj.name.trim()) {
            Toast('Please enter category score type name', "error");
            return false;
        }
        if (!formObj.code || !formObj.code.trim()) {
            Toast('Please enter category score type code', "error");
            return false;
        }
        if (!formObj.description || !formObj.description.trim()) {
            Toast('Please enter category score type description', "error");
            return false;
        }
        return true;
    }

    const handleCategoryScoreType = () => {
        if (!isValidInput(formField)) return;
        HttpService.postRequest(API_URL.ADD_CATEGORY_SCORE_TYPE, formField).then(
            (res: any) => {
                Toast(selectedItem?.id ?  'Prompt category score type updated successfully.' : 'Prompt category score type added successfully.', "success");
                setIsOpenAddEdit(false);
                setIsLoad(true);
            },
            (err: any) => {
                Toast(err.message, "error");
            }
        );
    }

    const generateCode = () => {
        if (!formField.name || !formField.name.trim()) {
            Toast('Please enter category score type name', "error");
            return false;
        }
        HttpService.postRequest(API_URL.GENERATE_CODE, formField.name).then(
            (res: any) => {
                setFormField({
                    ...formField,
                    code: res ? res : null
                });
            }
        ).catch((err: any) => {
            Toast(err.message, "error");
        });
    }

    return (
        <div>
            <Modal
                isOpen={isOpenAddEdit}
                srLabelledBy={'modal-id-categoryscoretype'}
                srDescribedBy={'modal-id-categoryscoretype'}
                onUserRequest={handleUserRequest}>
                <ModalHeader
                    titleId={'modal-id-categoryscoretype'}
                    isFullscreenButtonVisible={false}
                    onUserRequest={() => handleUserRequest('header')}>
                    {selectedItem?.id ? 'Edit Category Score Type' : 'Add Category Score Type'}
                </ModalHeader>
                <ModalBody descriptionId="modal-id-categoryscoretype">
                    <div className='wk-grid-page-container p-0'>
                        <div className="wk-grid mt-10">
                            <div className="wk-column-12">
                                <InputField label="Name" labelFor="categoryscoretype-name-1" size="small" indicator="required">
                                    <input
                                        type="text" id="categoryscoretype-name-1" name="name"
                                        placeholder="Category Score Type Name"
                                        onChange={(event: any) => handleInputChange(event)}
                                        value={formField.name} autoComplete="off"
                                    />
                                </InputField>
                                <div className="cg-field-header">
                                    <label className="cg-field-label pt-15">Code <div className="cg-field-required-indicator"><span aria-hidden="true">*</span><div data-e2e="cg-sr-only" className="cg-sr-only">Required field</div></div></label>
                                    <div className="pt-5">
                                        <button type="button" className="border border-primary btn btn btn-outline-light text-bg-light"
                                            style={{ padding: '.25rem .5rem', fontSize: '.75rem', color: '#9A67F3' }}
                                            onClick={generateCode}>
                                            Generate Code
                                        </button>
                                    </div>
                                </div>
                                <InputField label="" labelFor="categoryscoretype-code-1" size="small" indicator="required">
                                    <input
                                        type="text" id="categoryscoretype-code-1" name="code"
                                        placeholder="Category Score Type Code"
                                        readOnly
                                        onChange={(event: any) => handleInputChange(event)}
                                        value={formField.code} autoComplete="off"
                                    />
                                </InputField>
                                <div className="">
                                    <TextareaField label="Description" labelFor="categoryscoretype-description-1" indicator="required">
                                        <textarea style={{ height: '10rem' }}
                                            id="categoryscoretype-code-1" name="description"
                                            placeholder="Category Score Type Description"
                                            onChange={(event: any) => handleInputChange(event)}
                                            value={formField.description}
                                        ></textarea>
                                    </TextareaField>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup mode="static">
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField size={'small'} iconPosition={'left'}>
                                <button
                                    className='mr-10'
                                    type="button"
                                    id="save"
                                    onClick={handleCategoryScoreType}>
                                    Save
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default AddCategoryScoreType;